import { toCx } from '../../../classname.js';

var shadowStyleMapper = {
  boxShadow: function boxShadow(value, _) {
    return {
      classNames: [toCx('shadow', value)]
    };
  }
};

export { shadowStyleMapper };
//# sourceMappingURL=shadow.js.map
